import { ImgHTMLAttributes } from 'react';
import styled from 'styled-components/macro';

import { EVColors } from 'ev-theme/styles';

interface HeaderContainerProps {
  hasDivider?: boolean;
  isMobile?: boolean;
}

interface HeaderLogoProps extends ImgHTMLAttributes<HTMLImageElement> {
  altText?: string;
}

export const HeaderContainer = styled.header.attrs({
  'data-testid': 'header',
})<HeaderContainerProps>`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: 0 24px;
  height: 75px;
  ${props => props.isMobile && `height: 48px;`}
  ${props =>
    props.hasDivider && `border-bottom: 1px solid ${EVColors.border.subtle};`}
`;

export const HeaderLogo = styled.img.attrs<HeaderLogoProps>(props => ({
  alt: props.altText || 'Logo',
  'data-testid': 'logo',
  width: props.width || '110px',
}))<HeaderLogoProps>`
  margin-right: auto;
  max-height: 33px;
`;
